import { default as app, collapsibleHeaderClickEvent, onWindowResize, resetSelectionColumn, ToggleYellowToGreen, ToggleGreenToYellow, IsUndefinedOrNull } from '@legacy/App';

app.factory('PaymentTermFactory', ['$http', 'settings', function ($http, settings) {
    return {
        getPaymentTermList: function (companyId) {
            return $http.get(settings.ApiURL + settings.PaymentTermsURL + "/paymentterms/" + companyId);
        },
        getNewPaymentTerm: function () {
            return $http.get(settings.ApiURL + settings.PaymentTermsURL + "/newpaymentterm");
        },
        getPaymentTermDetails: function (companyId, paymentTermId) {
            return $http.get(settings.ApiURL + settings.PaymentTermsURL + '/' + companyId + '/' + paymentTermId);
        },
        getPaymentTermOptionList: function () {
            return $http.get(settings.ApiURL + settings.PaymentTermsURL + "/paymenttermoption");
        },
        getCompanyList: function() {
            return $http.get(settings.ApiURL + settings.CompanyURL + "/dropdown/0")
        },
        savePaymentTerm: function (paymentTerm, originalId) {
            return $http.put(settings.ApiURL + settings.PaymentTermsURL + '/' + originalId, paymentTerm);
        },
        deletePaymentTerm: function (companyId, paymentTermId) {
            return $http.delete(settings.ApiURL + settings.PaymentTermsURL + '/' + companyId + '/' + paymentTermId);
        }        
    };
}]);

app.controller('PaymentTermController', ['$q', '$scope', 'PaymentTermFactory', '$rootScope', 'settings', 'masterFactory',
                                function ($q, $scope, PaymentTermFactory, $rootScope, settings, masterFactory) {
    $rootScope.pageTitle = "Payment Term";
    $scope.paymentTerms = [];
    $scope.companies = [];
    $scope.paymentTerm = {};
    $scope.newpaymentTerm = {};
    $scope.paymentTermOptions = [];
    $scope.selectedCompany = -1;
    $scope.selectedPaymentTerm = -1;
    $scope.isNew = false;
    $scope.error = "";
    $scope.modelState = [];
    $scope.isFormVisible = false;
    $scope.pageSize = 20;

    // Initialization - this runs on load
    var init = function () {
        masterFactory.verifyAuthentication();

        $('#loadingModal').modal({ backdrop: 'static' });

        $q.all([
            PaymentTermFactory.getCompanyList().success(function (response) {
                $scope.companies = response;
                $scope.selectedCompany = $scope.companies[0].Id;
                if ($scope.selectedCompany != null && $scope.selectedCompany != undefined && $scope.selectedCompany > 0) {
                    PaymentTermFactory.getPaymentTermList($scope.selectedCompany).success(function (data) {
                        $scope.paymentTerms = data;
                        $scope.refreshGrid(0, null);
                    }).error(function (data, status) {
                        masterFactory.setError(status, data, $scope);
                    });
                }
                else {
                    $scope.paymentTerms = [];
                }                
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }),
            PaymentTermFactory.getNewPaymentTerm().success(function (data) {
                $scope.newpaymentTerm = data;
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }),
            PaymentTermFactory.getPaymentTermOptionList().success(function (data) {
                $scope.paymentTermOptions = data;
            }).error(function (data,status) {
                masterFactory.setError(status, data, $scope);
            })
        ]).then(function () {
            $('#loadingModal').modal('hide');
        });

    };

    var getPaymentTermDetails = function (companyId, Id) {
        $('#loadingModal').modal({ backdrop: 'static' });
        PaymentTermFactory.getPaymentTermDetails(companyId, Id).success(function (data) {
            $scope.paymentTerm = data;            
        }).error(function (data, status) {
            masterFactory.setError(status, data, $scope);
        }).finally(function () {
            $('#loadingModal').modal('hide');
        });
    };

    init();

    // Grid renderers
    $scope.refreshGrid = function (PageIndex, Key) {        
        $('#gridPaymentTerm').dxDataGrid({
            dataSource: {
                store: {
                    data: $scope.paymentTerms,
                    type: 'array',
                    key: 'Id'
                }
            },            
            noDataText: "No Payment Terms Found",
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            rowAlternationEnabled: false,
            contentReadyAction: grdReadyAction,
            selection: { mode: 'single' },
            paging: {
                pageSize: $scope.pageSize,
                pageIndex: PageIndex
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 30]
            },
            filterRow: {
                visible: true
            },
            groupPanel: {
                visible: false,
            },
            columns: [
               {
                   caption: 'ID',
                   dataField: 'Id',
                   cssClass: 'Id',
                   dataType: 'number',
                   alignment: 'center',
                   width: 100,
                   cellTemplate: function (container, options) {
                       $('<span />').text(options.data.Id).appendTo(container);
                       container.addClass('grid-cell-align-left');
                   }
               },
               {
                   caption: 'Payment Term',
                   dataField: 'Name',
                   cssClass: 'Name',
                   dataType: 'string',
                   alignment: 'center',
                   cellTemplate: function (container, options) {
                       $('<span />').text(options.data.Name).appendTo(container);
                       container.addClass('grid-cell-align-left');
                   }
               }
            ],
            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData[0] != null) {
                    getPaymentTermDetails($scope.selectedCompany, selectedRowsInfo.selectedRowsData[0].Id);
                    $scope.originalId = selectedRowsInfo.selectedRowsData[0].Id;
                }
                else $scope.paymentTerm = angular.copy($scope.newpaymentTerm);

                $scope.error = "";
                $scope.isNew = false;
                $scope.isFormVisible = true;
                $scope.isDeleteVisible = true;
                ToggleYellowToGreen();
                $rootScope.pageTitle = "Payment Terms";                                    
            }

        });

        if (Key != null && Key > 0) {
            var dataGrid = $('#gridPaymentTerm').dxDataGrid('instance');
            (dataGrid as unknown as FacnmDx).selectRows([Key]);
        }   
    };

    // Button click functions and submit form function
    $scope.addNewEntity = function () {
        $rootScope.pageTitle = "New Payment Term";
        $scope.originalId = -1;
        $scope.error = "";
        $scope.isFormVisible = true;
        $scope.isDeleteVisible = false;
        $scope.isNew = true;
        $scope.paymentTerm = angular.copy($scope.newpaymentTerm);
        $scope.paymentTerm.CompanyId = $scope.selectedCompany;
        ToggleGreenToYellow();
    };

    $scope.confirmDeleteEntity = function () {
        $('#DeleteModal').modal({ backdrop: 'static' });
    };

    $scope.deleteEntity = function (value) {
        if (value == 0) {
            $('#DeleteModal').modal('hide');
        }
        else if (value == 1) {
            PaymentTermFactory.deletePaymentTerm($scope.paymentTerm.CompanyId, $scope.paymentTerm.Id).success(function (data) {
                PaymentTermFactory.getPaymentTermList($scope.selectedCompany).success(function (data) {
                    var dataGrid = $('#gridPaymentTerm').dxDataGrid('instance');
                    var pageIndex = dataGrid.pageIndex();
                    $scope.pageSize = dataGrid.pageSize();
                    dataGrid.clearSelection();
                    $scope.paymentTerms = data;
                    $scope.cancelForm();
                    $scope.refreshGrid(pageIndex, null);                    
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Deleted Payment Term successfully' });
                });
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#DeleteModal').modal('hide');
            });
        }
    };    

    $scope.cancelForm = function () {        
        var dataGrid = $('#gridPaymentTerm').dxDataGrid('instance');
        dataGrid.clearSelection();
        $scope.isFormVisible = false;
        $scope.paymentTermForm.submitted = false;
        $scope.closeModelStateErrors();
        $scope.closeAlert();
    };

    $scope.reset = function (type) {        
        var dataGrid = $('#gridPaymentTerm').dxDataGrid('instance');
        var selectedRow = dataGrid.getSelectedRowsData()[0];
        if (type == 'update' && selectedRow != null) { // get db payment term and set to scope.payment term.
            getPaymentTermDetails($scope.selectedCompany, selectedRow.Id);
            $rootScope.pageTitle = "Payment Terms";            
        }
        else {
            $scope.paymentTerm = angular.copy($scope.newpaymentTerm);
            $scope.paymentTerm.CompanyId = $scope.selectedCompany;            
            $rootScope.pageTitle = "New Payment Term";
        }
        $scope.paymentTermForm.$setPristine();
        $scope.paymentTermForm.submitted = false;
        $scope.closeModelStateErrors();
        $scope.closeAlert();
        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Payment Term details were reset' });
    };

    $scope.submitForm = function () {
        $scope.error = "";
        if ($scope.paymentTermForm.$valid) {
            $scope.savePaymentTerm();
            $scope.paymentTermForm.submitted = false;
        } else {
            $scope.paymentTermForm.submitted = true;
        }
    };

    $scope.savePaymentTerm = function () {
        var pageindex;
        $scope.closeModelStateErrors();
        if ($scope.originalId == undefined || $scope.originalId == null)
            $scope.originalId = $scope.paymentTerm.Id;
        PaymentTermFactory.savePaymentTerm($scope.paymentTerm, $scope.originalId).success(function (data) {
            if (!IsUndefinedOrNull(data)) {
                $scope.selectedPaymentTerm = data.Id;                
                PaymentTermFactory.getPaymentTermList($scope.selectedCompany).success(function (data) {                    
                    var dataGrid = $('#gridPaymentTerm').dxDataGrid('instance');
                    $scope.pageSize = dataGrid.pageSize();
                    pageindex = dataGrid.pageIndex();
                    $scope.paymentTerms = data;
                    if ($scope.paymentTerm.Id > 0) {
                        $scope.refreshGrid(pageindex, $scope.paymentTerm.Id)
                    }
                    else {
                        $scope.cancelForm();
                        $scope.refreshGrid(pageindex, null);
                    }
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    if ($scope.paymentTerm.Id > 0) {
                        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Payment Term successfully' });
                    }
                    else {
                        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Created Payment Term successfully' });
                    }
                });
            }            
        }).error(function (data, status) {
            masterFactory.setError(status, data, $scope);
        });
    };

    // Helping functions and events
    $(window).resize(function () {
        onWindowResize('#gridPaymentTerm', settings.GridMarginHeight + 42);
    });

    function grdReadyAction(e) {
        onWindowResize('#gridPaymentTerm', settings.GridMarginHeight + 42);
    };

    collapsibleHeaderClickEvent($scope);

    $scope.closeAlert = function () {
        $scope.error = null;
    };

    $scope.closeModelStateErrors = function () {
        $scope.modelState = [];
    };

    $scope.clickHalfDiv = function (control) {
        masterFactory.setFocus(control);
    };

    $scope.filter = function (input, id) {
        var i = 0, len = input.length;
        for (; i < len; i++) {
            if (+input[i].Id == +id) {
                return input[i];
            }
        }
        return null;
    };

    $scope.onCompanyChange = function () {
        if ($scope.selectedCompany != null && $scope.selectedCompany != undefined && $scope.selectedCompany > 0) {
            $('#loadingModal').modal({ backdrop: 'static' });
            PaymentTermFactory.getPaymentTermList($scope.selectedCompany).success(function (response) {
                $scope.paymentTerms = response;
                $scope.paymentTerm = {};
                $scope.isFormVisible = false;
                $scope.refreshGrid();
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            });
        }
        else {
            $scope.paymentTerms = [];
        }
    };
}]);